module.exports = __webpack_public_path__ + "img/guanwang.05c2581f.jpg";